/**
 *  Modal script file
**/

export default {
  name: 'app-modal',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    hasSlot (name) {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    }
  }
}
